module.exports = __webpack_public_path__ + "img/excel.991f1651.svg";